import React from 'react';
import { useHeap } from '../../hooks/useHeap';
import { KILLSWITCH_CONFIG } from '../../environment/killswitches';
import { useSupportBot } from '../hooks/useSupportBot';

const Heap = () => {
  useHeap();
  return null;
};

const SupportBot = () => {
  useSupportBot();
  return null;
};

export const IntegrationsInjector = () => {
  return (
    <>
      {KILLSWITCH_CONFIG.heapDisabled ? null : <Heap />}
      {KILLSWITCH_CONFIG.supportDisabled ? null : <SupportBot />}
    </>
  );
};
